import { Subject } from 'rxjs';

const metricSelectedSubject = new Subject();

export const updateMetricSelectedSubject = {
  update: message => metricSelectedSubject.next(message),
  clear: () => metricSelectedSubject.next(),
  get: () => metricSelectedSubject.asObservable()
};
